import React, {useCallback, useRef} from 'react';
import InputGroup from '@bonprix/pattern-library/templates/input/Group.jsx';
import CheckboxInput from '@bonprix/pattern-library/templates/input/Checkbox.jsx';
import Label from '@bonprix/pattern-library/templates/input/Label.jsx';
import {addToClickedFilters, fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from "../../ArticleOverviewHelper";

function Checkbox({filterOptionChange, identifier, filterOptions, trackingId, hideNumberOfItems}) {
    const clickedFilters = useRef(fillInitialClickedFilters(filterOptions));

    const handleClick = useCallback((optionValue, event) => {
        event.preventDefault();
        clickedFilters.current = addToClickedFilters(optionValue, clickedFilters.current);
        yieldToMain(() => filterOptionChange(identifier, trackingId, clickedFilters.current));
        }, []);
    
    return (
        <div className="filter__checkbox">
            {filterOptions.map((option, index) => {
                return renderFilterOption(option, hideNumberOfItems, index);
            })}
        </div>
    );

    function renderFilterOption(option, hideNumberOfItems, index) {
        return (
            <div className="filter__option -checkbox" key={index}>
                <InputGroup className="filter__checkbox-button">
                    <CheckboxInput
                        checked={clickedFilters.current.includes(option.value)}
                        onChange={(event) => handleClick(option.value, event)}
                        value={option.value}
                    />

                    <div className="input-group__text">
                        {option.seoHref ? (
                            <a href={option.seoHref} className="optimized-filter">
                                {renderLabel(option.name, option.numberOfItems, hideNumberOfItems)}
                            </a>
                        ) : (
                            renderLabel(option.name, option.numberOfItems, hideNumberOfItems)
                        )}
                    </div>
                </InputGroup>
            </div>
        );
    }

    function renderLabel(name, numberOfItems, hideNumberOfItems) {
        return (
            <>
                <Label className="input-group__label-name">{name}</Label>
                {hideNumberOfItems ? <></> : <Label className="input-group__label-hits">({numberOfItems})</Label>}
            </>
        );
    }
}

export default React.memo(Checkbox)
